/**
 * @fileoverview Agent definition for draft-refiner-v2.
 *
 * This agent critiques and rewrites a given chapter draft, analyzing
 * prose quality and character consistency before producing a refined version.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'draft-refiner-v2',
  kind: 'primitive',
  name: 'Draft Refiner',
  description: 'Critiques and rewrites a given chapter draft using extensive context.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-05',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [],
    usedInComposites: ['run-refine-v2', 'run-refine-full-v2'],
    relatedAgents: [
      'refine-synthesizer',
      'chapter-drafter-v2',
      'chapter-drafter-v2-neutral',
      'style-aligner-v2',
    ],
  },
};
